import { FC, Fragment, useState, useEffect } from "react";
import clsx from "clsx";
import ImgWithPlaceholder from "~/components/ImgWithPlaceholder";

export const enum TokenIconSize {
    small = "small",
    medium = "medium",
    mini = "mini",
    miniMd = "mini-md",
    miniMdBg0 = "mini-md-bg0",
    body1 = "body1",
    mini32 = "mini32",
    mini21 = "mini21",
    mini16 = "mini16",
    size36 = "size36",
    size40 = "size40",
}
export type SizeValues = `${TokenIconSize}`;

export type TokenIconProps = {
    icon: string;
    symbol?: string;
    size?: SizeValues;
    isNetwork?: boolean;
    tailIconClass?: string;
};

export const TokenIcon: FC<TokenIconProps> = ({
    icon = "",
    symbol = "",
    /**
     * @default Size.small
     * small 44px
     * medium 56px
     * mini-md 24px
     * mini 18px
     */
    size = TokenIconSize.small,
    tailIconClass = "",
    isNetwork = false,
}) => {
    const [loadError, setLoadError] = useState(false);
    const [loaded, setLoaded] = useState(false);
    let appendClass = "";
    if (size === TokenIconSize.small) {
        appendClass = "w-[44px] h-[44px]";
    } else if (size === TokenIconSize.size40) {
        appendClass = "w-[40px] h-[40px]";
    } else if (size === TokenIconSize.size36) {
        appendClass = "w-[36px] h-[36px]";
    } else if (size === TokenIconSize.medium) {
        appendClass = "w-[56px] h-[56px] !text-h4";
    } else if (size === TokenIconSize.mini) {
        appendClass = "w-[18px] h-[18px] !text-direction3";
    } else if (size === TokenIconSize.mini16) {
        appendClass = "w-[16px] h-[16px] !text-direction3";
    } else if (size === TokenIconSize.miniMd) {
        appendClass = "w-[24px] h-[24px] !text-direction3";
    } else if (size === TokenIconSize.miniMdBg0) {
        appendClass = "w-[24px] h-[24px] !text-direction3 bg-bg_0";
    } else if (size === TokenIconSize.body1) {
        appendClass = "w-[24px] h-[24px] !text-body1";
    } else if (size === TokenIconSize.mini32) {
        appendClass = "w-[32px] h-[32px] !text-body1";
    } else if (size === TokenIconSize.mini21) {
        appendClass = "w-[21px] h-[21px] !text-body1";
    }

    const showIcon = icon && !loadError && loaded;

    useEffect(() => {
        setLoadError(false);
    }, [icon]);

    return (
        <Fragment>
            <div
                className={clsx("rounded-full bg-bg_bottom", {
                    hidden: !showIcon,
                })}
            >
                {icon && (
                    <ImgWithPlaceholder
                        className={clsx(
                            "rounded-full",
                            appendClass,
                            tailIconClass,
                            {
                                hidden: loadError,
                            }
                        )}
                        src={icon}
                        onError={() => setLoadError(true)}
                        onload={() => setLoaded(true)}
                    />
                )}
            </div>

            <div
                className={clsx(
                    "flex justify-center items-center rounded-full text-h5 font-Semibold border-[2px] border-bg_0",
                    isNetwork ? "text-bg_0 bg-text_1" : "bg-bg_6 text-white",
                    appendClass,
                    tailIconClass,
                    {
                        hidden: showIcon,
                    }
                )}
            >
                {symbol?.slice?.(0, 1)?.toUpperCase()}
            </div>

            {/* {icon ? (
                <div className={clsx('rounded-full bg-bg_bottom', appendClass)}>
                    <ImgWithPlaceholder className={clsx('rounded-full', appendClass)} src={icon}  onError={()=>setLoadError(true)}/>
                </div>
            ) : (
                <div
                    className={clsx(
                        'flex justify-center items-center rounded-full bg-bg_6 text-h5 text-white font-Semibold',
                        appendClass,
                    )}
                >
                    {symbol.slice(0, 1).toUpperCase()}
                </div>
            )} */}
        </Fragment>
    );
};
